import React from "react";
import styles from "./Partners.module.scss";
import Image from "next/image";
import Link from "next/link";

const Partners = () => {
  return (
    <section className={styles.Partners}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            Swap to get
            <br />
            <span className={styles.titleSpan}> B-Love Tokens </span>
          </h1>

          <p className={styles.paraghraph}>
            B-Love tokens will be exclusively available on{' '}
            <u className='cursor-pointer'>
              <Link href={'https://xchangeon.io/'} target='_blank'>
                XchangeOn.io
              </Link>
            </u>{' '}
            and
            <u className='cursor-pointer'>
              <Link href={'https://dexa.exchange/'} target='_blank'>
                Dexa.exchange
              </Link>
            </u>{' '}
            . BLV tokens can be obtained by swapping BFICoins for BLV tokens.
            Else, users can also purchase BLV tokens through ITOs conducted at{' '}
            <u className='cursor-pointer'>
              <Link href={'https://xchangeon.io/'} target='_blank'>
                XchangeOn.io
              </Link>
            </u>
            .
          </p>

          <button className={styles.btn}>Learn More</button>
        </div>

        <div className={styles.imageWrapper}>
          <Image
            className={styles.image}
            src='/assets/Image/platform.png'
            width={550}
            height={560}
            alt='platform'
          />
        </div>
      </div>
    </section>
  )
};

export default Partners;
